/**
 *
 *
 */
export class IosScrollPreservation {
    private savedScrollY: number | null = null;
    private isSheetPresenting = false;

    private readonly htmlObserver = new MutationObserver(() => {
        const isHidden = document.documentElement.style.overflow === 'hidden';
        if (isHidden) {
            this.isSheetPresenting = true;
            this.restoreScrollY();
        } else if (this.isSheetPresenting) {
            this.isSheetPresenting = false;
            this.restoreScrollY();
        }
    });

    private readonly basketObserver = new MutationObserver(() => {
        if (this.savedScrollY !== null) {
            const scrollY = this.savedScrollY;
            if (!this.isSheetPresenting) {
                this.savedScrollY = null;
            }
            requestAnimationFrame(() => window.scrollTo(0, scrollY));
        }
    });

    private constructor() {
        document.addEventListener('oc-property-change', this.onPropertyChange, true);
        document.addEventListener('change', this.onPropertyChange, true);

        this.htmlObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['style']
        });

        const basket = document.getElementsByClassName('order_js_basket')[0] || document.getElementsByClassName('order_js_checkout_basket')[0];
        if (basket) {
            this.basketObserver.observe(basket, { childList: true });
        }
    }

    static initialize(): void {
        if (document.documentElement.classList.contains('app')) {
            new IosScrollPreservation();
        }
    }

    private restoreScrollY(): void {
        if (this.savedScrollY !== null) {
            const scrollY = this.savedScrollY;
            requestAnimationFrame(() => window.scrollTo(0, scrollY));
        }
    }

    private onPropertyChange = (event: Event): void => {
        const target = event.target as Element | null;
        if (
            target?.closest('.or_js_itemService__checkbox') ||
            target?.closest('.order_js_quantitySelection') ||
            target?.closest('.order_js_serviceQuantitySelection')
        ) {
            this.savedScrollY = window.scrollY;
        }
    };
}
